import { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Context } from "../Context.jsx";
import Navbar from "../components/Navbar.jsx";
import Hero from "../components/Hero.jsx";
import Features from "../components/Features/Features.jsx";
import Command from "../components/Command.jsx";
import Footer from "../components/Footer.jsx";

export default function Home() {
  const location = useLocation();
  const context = useContext(Context);
  const discordBotInviteURL = context.urls.discordBotInviteURL;

  useEffect(() => {
    if (location.state?.scrollToFeatures) {
      document.getElementById("features").scrollIntoView({ behavior: "smooth" });
    } else if (location.state?.scrollToCommands) {
      document.getElementById("commands").scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return (
    <div>
      <Navbar />
      <Hero />
      <Features />
      <Command />
      <div className="bg-[var(--fourth-colour)] border-x-2 border-black border-dashed">
        <div className="w-4/5 mx-auto py-20">
          <h3 className="text-3xl md:text-4xl font-medium">
            Read to Start Your Fishing Adventure?
          </h3>
          <p className="text-xl max-w-xl">
            Add Fishcord to your server today and bring the thrill of fishing to
            your community!
          </p>
          <a href={discordBotInviteURL} target="_blank" rel="noreferrer">
            <button className="mt-4 p-4 text-xl rounded-lg border border-black bg-black text-primaryColor hover:bg-secondaryColor hover:text-black hover:rounded-none duration-300">
              Add to Server
            </button>
          </a>
        </div>
      </div>

      <div className="border-x-2 border-black border-dashed pt-20">
        <Footer />
      </div>
    </div>
  );
}
